import React from 'react';
import { Document, Page, Text, View, Image, pdf, Link } from '@react-pdf/renderer';
import empresasData from "../../../../lib/json/empresas.json";
import PedidoCompra from "../../../../lib/json/consultas/PedidoCompraPDF.json"
import { styles } from './styles';
import ConsultaTotvs from '../../../../backend/ConsultaTotvs';
import { formatarComoMoeda, formatarData } from '../../../contents/VariaveisGlobais';

async function PedidoCompraPDF(numeroPedido, empresa, filial){
    const gerarPDFPedido = async(numeroPedido, empresa, filial) => {
		let consultaDefault = PedidoCompra.consulta;
        let tabelasDefault = PedidoCompra.tabelas;
		let empresaFilial = empresa + filial;
    	let empresaLogado = empresasData.empresas.find((empresa) => empresa.empresaFilial === empresaFilial);
		
		consultaDefault += " AND C7_NUM = '" + numeroPedido + "' ORDER BY C7_FILIAL, C7_NUM, C7_ITEM"

		let retConsulta = await ConsultaTotvs( consultaDefault, tabelasDefault, empresaFilial );
		let dataPedido = retConsulta.data

		let totalFrete = 0;
		let totalICMSST = 0;
		let totalIPi = 0;
		let totalDesconto = 0;
		let totalDespesas = 0;
		let totalSeguro = 0;
		let totalPedido = 0;
		let totalGeral = 0;
		let tipoFrete = ( dataPedido[0].C7_TPFRETE === 'C' ? "CIF" : ( dataPedido[0].C7_TPFRETE === 'F' ? "FOB" : "" ) )

		const MyDocument = (
			<Document>
				<Page size="A4" orientation="landscape" style={styles.page}>
					<View style={styles.viewRow}>
						<View style={styles.viewImagem}>
							<Image src={`${process.env.PUBLIC_URL}/${empresaLogado.logoEmpresa}`} style={styles.logo} />
						</View>
						<View style={styles.viewEmpresa}>
							<Text style={styles.normalText}>{dataPedido[0].M0_NOMECOM}</Text>
																			   
																		
							<Text style={styles.normalText}>ENDEREÇO: {dataPedido[0].M0_ENDENT + " - " + dataPedido[0].M0_BAIRENT}</Text>
							<Text style={styles.normalText}>CEP: {dataPedido[0].M0_CEPENT}</Text>
							<Text style={styles.normalText}>CIDADE: {dataPedido[0].M0_CIDENT + '/' + dataPedido[0].M0_ESTENT}</Text>
							<Text style={styles.normalText}>FONE: {dataPedido[0].M0_TEL}</Text>
							<View style={styles.dividerHeader} />
							<Text style={styles.normalText}>CNPJ: {dataPedido[0].M0_CGC}</Text>
						</View>
						<View style={styles.viewPedido}>
							<Text style={styles.normalText}>Nº Pedido Compra: </Text>
							<Text style={styles.boldText}>{numeroPedido}</Text>
							<Text style={styles.normalText}>Emissão:</Text>
							<Text style={styles.boldText}>{formatarData(dataPedido[0].C7_EMISSAO)}</Text>
						</View>
					</View>
					
					<View style={styles.divider} />
					
					<View style={styles.viewRow}>
						<View style={styles.viewFornecedor}>
							<Text style={styles.boldText}>Fornecedor:
								<Text style={styles.normalText}> {dataPedido[0].A2_COD + "/" + dataPedido[0].A2_LOJA + " - " + dataPedido[0].A2_NOME.trim()}</Text>
							</Text>
							<Text style={styles.boldText}>Endereço:
								<Text style={styles.normalText}> {dataPedido[0].A2_END.trim()}</Text>
							</Text>
							<Text style={styles.boldText}>Bairro:
								<Text style={styles.normalText}> {dataPedido[0].A2_BAIRRO.trim()}</Text>
							</Text>
							<Text style={styles.boldText}>Municipio:
								<Text style={styles.normalText}> {dataPedido[0].A2_MUN.trim() + " - " + dataPedido[0].A2_EST}</Text>
							</Text>
							<Text style={styles.boldText}>IE:
								<Text style={styles.normalText}> {dataPedido[0].A2_INSCR}</Text>
							</Text>
						</View>
						<View style={styles.viewFornecedor}>
							<Text style={styles.boldText}>CEP:
								<Text style={styles.normalText}> {dataPedido[0].A2_CEP}</Text>
							</Text>
							<Text style={styles.boldText}>Telefone:
								<Text style={styles.normalText}> {dataPedido[0].A2_TEL}</Text>
							</Text>
							<Text style={styles.boldText}>E-mail:
								<Text style={styles.normalText}> {dataPedido[0].C7_XEMAIL.trim() ? dataPedido[0].C7_XEMAIL.trim() : dataPedido[0].A2_EMAIL.trim()}</Text>
							</Text>
							<Text style={styles.boldText}>CNPJ:
								<Text style={styles.normalText}> {dataPedido[0].A2_CGC}</Text>
							</Text>
							<Text style={styles.boldText}>Contato:
								<Text style={styles.normalText}> {dataPedido[0].C7_CONTATO.trim()}</Text>
							</Text>
						</View>
					</View>

					<View style={styles.table}>
						<View style={styles.tableRow}>
							<Text style={[styles.celulaBorderBold, {width:"5%" }]}>Item</Text>
							<Text style={[styles.celulaBorderBold, {width:"25%"}]}>Produto</Text>
							<Text style={[styles.celulaBorderBold, {width:"20%"}]}>Centro de Custo</Text>
							<Text style={[styles.celulaBorderBold, {width:"10%"}]}>Dt. Entrega</Text>
							<Text style={[styles.celulaBorderBold, {width:"10%" }]}>Quantidade</Text>
							<Text style={[styles.celulaBorderBold, {width:"10%" }]}>Valor Unit.</Text>
							<Text style={[styles.celulaBorderBold, {width:"10%" }]}>Impostos</Text>
							<Text style={[styles.celulaBorderBold, {width:"10%" }]}>Valor Total</Text>
						</View>

						{dataPedido.map((item, index) => {
							totalFrete += parseFloat(item.C7_VALFRE, 2);
							totalICMSST += parseFloat(item.C7_ICMSRET, 2)
							totalIPi += parseFloat(item.C7_VALIPI, 2)
							totalDesconto += parseFloat(item.C7_VLDESC, 2)
							totalDespesas += parseFloat(item.C7_DESPESA, 2)
							totalSeguro += parseFloat(item.C7_SEGURO, 2)
							totalPedido += parseFloat(item.C7_TOTAL, 2)
							
							let cImpostos = ''
							let celulaStyle = ( item.C7_OBS.trim().length === 0 ? styles.celulaBorder : styles.celulaNoBorder);
							
							cImpostos += ( parseFloat(item.C7_VALIPI) > 0 ? 'IPI: ' + formatarComoMoeda(item.C7_VALIPI,2) : '')
							cImpostos += ( parseFloat(item.C7_VALICM) > 0 ? ( cImpostos ? '</br>' : '' ) + 'ICMS: ' + formatarComoMoeda(item.C7_VALICM,2) : '')
							
							return (
								<View wrap={false}>
									<View key={index} style={styles.tableRow} wrap={false}>
										<Text style={[celulaStyle, {width:"5%"}]}>{item.C7_ITEM}</Text>
										<Text style={[celulaStyle, {width:"25%"}]}>{item.C7_PRODUTO.trim() + " - " + item.DESCRI.trim()}</Text>
										<Text style={[celulaStyle, {width:"20%"}]}>{item.C7_CC.trim() + " - " + item.C7_XDESCC.trim()}</Text>
										<Text style={[celulaStyle, {width:"10%"}]}>{formatarData(item.C7_DATPRF)}</Text>
										<Text style={[celulaStyle, {width:"10%", textAlign: 'right'}]}>{item.C7_QUANT} {item.C7_UM}</Text>
										<Text style={[celulaStyle, {width:"10%", textAlign: 'right'}]}>{formatarComoMoeda(item.C7_PRECO,4)}</Text>
										<Text style={[celulaStyle, {width:"10%", textAlign: 'right'}]}>{cImpostos}</Text>
										<Text style={[celulaStyle, {width:"10%", textAlign: 'right'}]}>{formatarComoMoeda(item.C7_TOTAL,2)}</Text>
									</View>
									<View key={index} style={styles.tableRow}>
										<Text style={[styles.celulaBorder, styles.boldText, {width:"90%" }]}>Descrição Complementar:
											<Text style={styles.normalText}> {item.C7_OBS.trim()}</Text>
										</Text>
										<Text style={[styles.celulaBorder, styles.boldText, {width:"10%" }]}>C. A.:
											<Text style={styles.normalText}> {item.C7_XCA.trim()}</Text>
										</Text>
									</View>
								</View>
							)
						})}
						{ totalFrete = 
								totalFrete === 0 
									? parseFloat(dataPedido[0].C7_FRETE, 2) 
									: totalFrete
						}
						{ totalGeral = totalSeguro + totalPedido + totalFrete + totalDespesas - totalDesconto }
					</View>

					<View style={styles.viewRowFinal}>
						<View style={{marginTop: 10, width: '70%'}}>
							<Text style={styles.boldText}>Moeda: 
								<Text style={styles.normalText}> Real</Text>
							</Text>
							<Text style={styles.boldText}>Condição de Pagamento: 
								<Text style={styles.normalText}> {dataPedido[0].C7_COND.trim() + " - " + dataPedido[0].E4_COND.trim() }</Text>
							</Text>
							<Text style={styles.boldText}>Tipo Frete: 
								<Text style={styles.normalText}> {tipoFrete}</Text>
							</Text>
							<View style={styles.dividerHeader} />
							<Text style={styles.boldText}>Comprador: 
								<Text style={styles.normalText}> {dataPedido[0].Y1_COD.trim() + " - " + dataPedido[0].Y1_NOME.trim() } </Text> 
							</Text>
							<Text style={styles.boldText}>Telefone: 
								<Text style={styles.normalText}> {dataPedido[0].Y1_TEL.trim() } </Text> 
							</Text> 
							<Text style={styles.boldText}>E-mail: 
								<Text style={styles.normalText}> {dataPedido[0].Y1_EMAIL.trim() } </Text> 
							</Text>
							<View style={styles.dividerHeader} />
							<Text style={styles.boldText}>Responsável pelo Recebimento: 
								<Text style={styles.normalText}> {dataPedido[0].NOMEUSUARIO.trim() } </Text> 
							</Text>
							<Text style={styles.boldText}>E-mail: 
								<Text style={styles.normalText}> {dataPedido[0].EMAILUSUARIO.trim() } </Text> 
							</Text>
							{ dataPedido[0].C7_XENDENT && dataPedido[0].C7_XENDENT.trim() && (
								<Text style={styles.boldText}>Endereço Entrega: 
									<Text style={styles.normalText}> {dataPedido[0].C7_XENDENT.trim() } </Text> 
								</Text>
							)}
							<View style={styles.dividerHeader} />
							<Text style={styles.boldText}>Dados de Faturamento: 
								<Text style={styles.normalText}> {dataPedido[0].M0_NOME} </Text> 
							</Text>
							<Text style={styles.normalText}>CNPJ: {dataPedido[0].M0_CGC} - IE: {dataPedido[0].M0_INSC} - FONE: {dataPedido[0].M0_TEL}</Text>
							<Text style={styles.normalText}>{dataPedido[0].M0_ENDENT + " - CEP: " + dataPedido[0].M0_CEPENT} - Cidade: {dataPedido[0].M0_CIDENT + '/' + dataPedido[0].M0_ESTENT}</Text>
							<View style={styles.dividerHeader} />

						</View>
						<View style={{marginTop: 10, width: '30%', textAlign: 'right'}}>
							{ totalFrete > 0 && (
								<Text style={styles.boldText}>Frete: 
									<Text style={styles.normalText}> {formatarComoMoeda(totalFrete, 2)}</Text>
								</Text>
							)}
							{ totalICMSST > 0 && (
								<Text style={styles.boldText}>ICMS ST: 
									<Text style={styles.normalText}> {formatarComoMoeda(totalICMSST, 2)}</Text>
								</Text>
							)}
							{ totalIPi > 0 && (
								<Text style={styles.boldText}>IPI: 
									<Text style={styles.normalText}> {formatarComoMoeda(totalIPi, 2)}</Text>
								</Text>
							)}
							{ totalDesconto > 0 && (
								<Text style={styles.boldText}>Desconto: 
									<Text style={styles.normalText}> {formatarComoMoeda(totalDesconto, 2)}</Text>
								</Text>
							)}
							{ totalDespesas > 0 && (
								<Text style={styles.boldText}>Despesas: 
									<Text style={styles.normalText}> {formatarComoMoeda(totalDespesas, 2)}</Text>
								</Text>
							)}
							{ totalSeguro > 0 && (
								<Text style={styles.boldText}>Seguro: 
									<Text style={styles.normalText}> {formatarComoMoeda(totalSeguro, 2)}</Text>
								</Text>
							)}
							<Text style={styles.boldText}>Total Pedido: 
								<Text style={styles.normalText}> {formatarComoMoeda(totalPedido, 2)}</Text>
							</Text>
							<Text style={styles.boldText}>Total Geral: 
								<Text style={styles.normalText}> {formatarComoMoeda(totalGeral, 2)}</Text>
							</Text>
						</View>
					</View>
					<View style={styles.rodape}>
						<Text style={styles.boldText}>Observação Fornecedor: </Text>
						{formatText(dataPedido[0].C7_OBSFOR.trim())}
					</View>
				</Page>
				<Page size="A4" orientation="portrait" style={styles.page}>
					<Text style={styles.boldTextH2}>REQUISITOS MÍNIMOS PARA ENTREGA:</Text>
					<Text style={styles.boldTextH4}>1 - O FORNECEDOR responsabiliza-se em entregar os materiais/produtos declarados no presente, em rigorosa observância aos prazos, preços, características, especificações, e condições constantes deste Pedido de Compra.</Text>
					<Text style={styles.normalText}>1.1 É obrigatório o uso de uniforme, capacete e calçado de segurança para todos os fornecedores, instaladores e prestadores de serviços que tenham necessidade de acesso à obra.</Text>
					<Text style={styles.normalText}>1.2 O FORNECEDOR deverá cumprir e se responsabilizar para que o Transportador cumpra os requisitos abaixo obrigatórios para entrega:</Text>
					<View>
						<Text style={styles.normalTextLI}>° A entrega deverá ser programada e agendada com antecedência com o {dataPedido[0].NOMEUSUARIO.trim()} (NPE), dentro dos horários de recebimento: Segunda à Sexta-feira das 8:00h às 15:00h</Text>
						<Text style={styles.normalTextLI}>° O Motorista deve portar: Carteira Nacional de Habilitação e Cédula de Identidade e utilizar os EPI`s obrigatórios. (Quando aplicável, o motorista deverá portar também o Certificado de Conclusão do Curso de Movimentação de Produtos Perigosos - MOPP)</Text>
					</View>
					<Text style={styles.normalText}>1.3 Sempre que aplicável, o recebimento somente ocorrerá com o acompanhamento dos seguintes documentos:</Text>
					<View>
						<Text style={styles.normalTextLI}>° Ficha de Dados de Segurança (FDS), Conforme a ABNT NBR 14725:2023 (não mais aceito a FISPQ).</Text>
						<Text style={styles.normalTextLI}>° Certificados de Materiais, Qualidade e Relatórios de Testes Efetuados.</Text>
						<Text style={styles.normalTextLI}>° Catálogos e manuais dos Produtos.</Text>
					</View>
					<View>
						<Text style={styles.normalText}>Em atendimento ao item 8.4 das normas ISO 9001 / 45001, a NPE informa que os critérios de qualificação e avaliação de fornecedor estão disponibilizados no site: <Link src="https://www.npegroup.com.br/wp-content/uploads/2024/09/CRITERIOS-DE-QUALIFICACAO-E-AVALIACAO-DE-FORNECEDORES-NPE-1.pdf">Critérios de Homologação e Avaliação de Fornecedores NPE</Link>.</Text>
					</View>
					<Text style={styles.boldTextH4}>2 - FORMA DE FATURAMENTO:</Text>
					<Text style={styles.normalText}>2.1 Para Materiais (DANFE), é indispensável que o FORNECEDOR, ao emitir a nota fiscal eletrónica, seja indicado o número do pedido de compra e o número do item do pedido de compra que estiver fornecendo, nos seguintes campos do arquivo XML:</Text>
					<View>
						<Text style={styles.normalTextLI}>° Campo "xped": número do pedido de compra</Text>
						<Text style={styles.normalTextLI}>° Campo "nitemped": número do item do pedido de compra</Text>
					</View>
					<Text style={styles.normalText}>O arquivo XML da nota fiscal eletrónica deverá ser enviado ao seguinte endereço: <Link src="mailto:contasapagar@npegroup.com.br">contasapagar@npegroup.com.br</Link>.</Text>
					<Text style={styles.normalText}>Mandatório citar no corpo da NF:</Text>
					<View>
						<Text style={styles.normalTextLI}>° Comprador: {dataPedido[0].Y1_NOME.trim()} - E-mail: {dataPedido[0].Y1_EMAIL.trim()}</Text>
						<Text style={styles.normalTextLI}>° Almoxarife: {dataPedido[0].NOMEUSUARIO.trim()} - E-mail: {dataPedido[0].EMAILUSUARIO.trim()}</Text>
						<Text style={styles.normalTextLI}>° Dados bancários: (relacionado ao CNPJ da NF)</Text>
					</View>
					<Text style={styles.normalText}>2.2 Para Serviços e Locações, o FORNECEDOR realizará a medição mensalmente ou Única quando for o caso, contemplando os serviços prestados ou locação entre o dia 21º (vigésimo primeiro) dia do mês e 20º (vigésimo) dia do mês subsequente.</Text>
					<Text style={styles.normalText}>O FORNECEDOR submeterá a medição e os demais documentos que comprovem a execução dos Serviços/Locação ('Boletim de Medição') a aprovação do {dataPedido[0].NOMEUSUARIO.trim()} (NPE), informando o número deste Pedido de Compra, no dia útil imediatamente subsequente ao dia de encerramento do período de medição. A NPE, por sua vez, o validará em até 5 (cinco) dias úteis de seu recebimento.</Text>
					<Text style={styles.normalText}>Aprovado o Boletim de Medição pela NPE, o FORNECEDOR apresentará a correspondente nota fiscal, sendo que esta deverá conter o número de pedido de compra e deverá ser enviada para o {dataPedido[0].NOMEUSUARIO.trim()} (NPE) e a contas a pagar no e-mail <Link src="mailto:contasapagar@npegroup.com.br">contasapagar@npegroup.com.br</Link>.</Text>
					<Text style={styles.normalText}>Deverá constar no corpo da nota fiscal:</Text>
					<View>
						<Text style={styles.normalTextLI}>° Nº da medição a que se refere o faturamento;</Text>
						<Text style={styles.normalTextLI}>° ISS / INSS</Text>
					</View>
					<Text style={styles.normalText}>2.3 Nas notas fiscais emitidas para a NPE, quando a operação for de Estados diferentes, adotar-se-á a alíquota interestadual e caberá ao Estado de localização do destinatário o imposto correspondente à diferença entre a alíquota interna do Estado destinatário e a alíquota interestadual, conforme Emenda Constitucional 87/2015, a mercadoria será para consumo final.</Text>
					<Text style={styles.boldTextH4}>3 - CONDIÇÕES DE PAGAMENTO:</Text>
					<Text style={styles.normalText}>3.1 O prazo de pagamento acordado é de {dataPedido[0].E4_COND.trim()} dias a contar da data da entrega dos materiais ou da emissão da nota fiscal / fatura de serviços/locação, sendo que a efetivação do pagamento ocorrerá às segunda-feira imediatamente após o vencimento ou nas quarta-feira, quando ocorrer o vencimento na terça-feira.</Text>
					<Text style={styles.normalText}>3.2 O pagamento será efetuado mediante crédito na conta corrente do FORNECEDOR a ser informada na nota fiscal, servindo o comprovante de depósito como prova de pagamento e quitação da quantia devida.</Text>
					<Text style={styles.normalText}>3.3 O FORNECEDOR renuncia expressamente ao que lhe faculta o Artigo 2º da Lei nº 5474/68, portanto fica vedada a extração de duplicata da fatura emitida em razão das notas fiscais/faturas, bem como o desconto de títulos em bancos e instituições financeiras ou factoring, levar título à protesto, dar esse Pedido de Compra em garantia, sem a prévia e expressa autorização da NPE.</Text>
					<Text style={styles.boldTextH4}>4 - CONDIÇÕES GERAIS:</Text>
					<Text style={styles.normalText}>O FORNECEDOR deverá refazer ou corrigir, às suas custas, os serviços executados com defeitos ou em desacordo com este Pedido de Compra, imediatamente após a sua identificação;</Text>
					<Text style={styles.normalText}>O FORNECEDOR deve prover a garantia completa do Material por ele fabricado e/ou fornecido, inclusive aqueles itens adquiridos de subfornecedores contra defeito de concepção, material, projeto ou fabricação, bem como pelo desempenho pelo prazo mínimo de garantia estabelecido em legislação aplicável.</Text>
					<Text style={styles.normalText}>O FORNECEDOR se obriga a indenizar a NPE por quaisquer danos sofridos em decorrência desse Pedido de Compra. Nenhuma das Partes será responsabilizada por danos indiretos e lucros cessantes.</Text>
					<Text style={styles.normalText}>Pelo atraso no cumprimento do prazo de entrega, indicado neste Pedido de Compra, o FORNECEDOR estará sujeito a multa compensatória de 0,5% (meio por cento) por dia de atraso, sobre o valor do item em atraso. O total das multas moratórias está limitado a 10% (dez por cento) do valor do PC. As referidas multas valem como valor mínimo de indenização, podendo a NPE exigir indenização suplementar no caso de prejuízo excedente ao valor da multa convencionada.</Text>
					<Text style={styles.normalText}>As Partes se obrigam a cumprir rigorosamente os ditames da Lei nº 13.709/2018 ' Lei Geral de Proteção de Dados ’ LGPD, se comprometendo a prestarem assistência mútua com suas obrigações, no limite de suas atribuições e responsabilidades, notadamente no que se refere ao dever de cautela e salvaguarda necessária para proteção dos dados.</Text>
					<Text style={styles.normalText}>O FORNECEDOR se compromete a agir com ética e transparência na execução deste Pedido de Compras e obedecer ao disposto no Código de Ética e Conduta de Fornecedor da NPE, disponibilizado no site <Link src="https://www.npegroup.com.br/wp-content/uploads/2024/01/Codigo-de-etica-e-conduta-de-fornecedores_NPE.pdf">Código de Ética e Conduta de Fornecedores NPE</Link>, sob pena de reparação por perdas e danos.</Text>
				</Page>
			</Document>
		);

		try{
			const pedido =  await pdf(MyDocument).toBlob();
			return pedido
		} catch (error) {
			console.error('Erro ao gerar PDF:', error);
			throw error;
		}	
	}

	return gerarPDFPedido(numeroPedido, empresa, filial);
};


const formatText = (texto) => { 
	const textoFormatado = texto
    	.replace(/\t/g, ' ')  // Substitui as tabulações por espaços
    	.split('\n')          // Divide o texto nas quebras de linha
    	.map((line, index) => (
      		<Text key={index} style={styles.normalText}>
        		{line}
      		</Text>
    ));

	return textoFormatado;
}


export default PedidoCompraPDF;
